module.exports = __webpack_public_path__ + "img/logo.7be8b626.png";